import { InjectionToken } from '@angular/core';

import { XMacroscopeProjectConfig } from './xmacroscope-project';


// eslint-disable-next-line @typescript-eslint/naming-convention
export const XMacroscopeProjectConfigService = new InjectionToken<XMacroscopeProjectConfig>('XMacroscopeProjectConfig');
